import {
    BuyProCheckout,
    BuyProConfirmation,
    BuyProIndividualProducts,
    BuyProLoading,
    EcommerceCheckoutWrapperComponent,
    EcommerceIndividualProducts,
    EcommerceOrderConfirmationComponent,
    EcommerceOrderLoadingComponent,
    EcommercePresets,
} from '@experiences/ecommerce';
import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';

import * as RouteNames from '../../common/constants/RouteNames';
import useCheckLicense from '../../common/hooks/useCheckLicense';
import EcommerceComponent from '../../component/ecommerce/EcommerceComponent';
import EcommerceManagePlanComponent from '../../component/ecommerce/EcommerceManagePlanComponent';
import { accountLogicalName } from '../../store/selectors';
import CheckGuard from '../helpers/CheckGuard';

export const useEcommerceRoutesK8s = () => {
    const EnableEcommerceIntegration = useFeatureFlagValue(Features.EnableEcommerceIntegration.name);
    const EnableEcommercePlanSelectionRevampM0 = useFeatureFlagValue(Features.EnableEcommercePlanSelectionRevampM0.name);

    const accountName = useSelector(accountLogicalName);

    const { isAccountLicenseEnterpriseOrPro } = useCheckLicense();

    return useMemo(() => [
        {
            path: BuyProCheckout,
            element:
                CheckGuard(EnableEcommerceIntegration && !isAccountLicenseEnterpriseOrPro(),
                    <EcommerceCheckoutWrapperComponent />,
                ),
        },
        {
            path: BuyProLoading,
            element: CheckGuard(EnableEcommerceIntegration && !isAccountLicenseEnterpriseOrPro(), <EcommerceOrderLoadingComponent />),
        },
        {
            path: BuyProConfirmation,
            element:
                CheckGuard(EnableEcommerceIntegration,
                    <EcommerceOrderConfirmationComponent />,
                ),
        },
        {
            path: RouteNames.BuyPro,
            element: EnableEcommercePlanSelectionRevampM0 ? (
                <Navigate to={RouteNames.BuyProPresets.replace(':accountName', accountName)} />
            ) :
                CheckGuard(EnableEcommerceIntegration && !isAccountLicenseEnterpriseOrPro(), <EcommerceComponent />),
        },
        {
            path: RouteNames.BuyEnterprise,
            element: EnableEcommercePlanSelectionRevampM0 ? (
                <Navigate to={RouteNames.BuyProPresets.replace(':accountName', accountName)} />
            ) :
                CheckGuard(EnableEcommerceIntegration && !isAccountLicenseEnterpriseOrPro(), <EcommerceComponent />),
        },
        {
            path: RouteNames.BuyProPresets,
            element:
                !EnableEcommercePlanSelectionRevampM0
                    ? <Navigate to={RouteNames.BuyPro.replace(':accountName', accountName)} />
                    : CheckGuard(EnableEcommerceIntegration && !isAccountLicenseEnterpriseOrPro(),
                        <EcommercePresets isDirectBuyFlow={false} />),
        },
        {
            path: BuyProIndividualProducts,
            element:
                CheckGuard(EnableEcommercePlanSelectionRevampM0 && EnableEcommerceIntegration && !isAccountLicenseEnterpriseOrPro(),
                    <EcommerceIndividualProducts isDirectBuyFlow={false} />),
        },
        {
            path: RouteNames.ManagePlan,
            element:
                CheckGuard(
                    EnableEcommerceIntegration && isAccountLicenseEnterpriseOrPro(),
                    <EcommerceManagePlanComponent />,
                ),
        },
    ], [ EnableEcommerceIntegration, EnableEcommercePlanSelectionRevampM0, accountName, isAccountLicenseEnterpriseOrPro ]);
};
